import { format } from 'date-fns';
import {
	START_DATE_TYPE,
	UPDATED,
	CREATED,
	DUE_DATE_TYPE,
	DATE_CF_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { StringValue } from '../../../value/types.tsx';
import type { SUPPORTED_DATE_TYPES } from '../types.tsx';

const getDateValue: StringValue<{
	fieldId: string;
	type: SUPPORTED_DATE_TYPES;
	value: string | null;
}> = (field) => {
	if (field.value && (field.type === CREATED || field.type === UPDATED)) {
		return format(new Date(field.value), 'yyyy-MM-dd');
	}
	return field.value || '';
};

export const dateStringValueHandler = {
	[START_DATE_TYPE]: getDateValue,
	[UPDATED]: getDateValue,
	[CREATED]: getDateValue,
	[DUE_DATE_TYPE]: getDateValue,
	[DATE_CF_TYPE]: getDateValue,
};
